import { useQuery } from "@tanstack/react-query";
import { orgHierarchyService } from "@/services/orgHierarchyService";

export function useOrgHierarchy() {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["org-hierarchy"],
    queryFn: () => orgHierarchyService.getOrgHierarchy(),
  });

  return {
    orgTree: data?.root ?? null,
    totalMembers: data?.totalMembers ?? 0,
    maxDepth: data?.maxDepth ?? 0,
    departments: data?.departments ?? [],
    loading: isLoading,
    error: error ? (error instanceof Error ? error.message : "Failed to load org chart") : null,
    refetch,
  };
}
